export const filtersTranslationKeys = {
  filtersCollapseHideText: 'filters.hide-filters',
  filtersCollapseShowText: 'filters.show-filters',
  filtersTitle: 'postbacks.filters',
  statisticsFiltersApplyFilters: 'statistics.filters-apply-filters',
  statisticsFiltersClearAll: 'statistics.filters-clear-all',
}
